import { Provider } from '@angular/core';
import { TICKET_FROM_CLIENT_REPOSITORY } from './application/ticket-from-client.tokens';
import { HttpTicketFromClientRepository } from './infrastructure/http/http-ticket-from-client.repository';
import { GetTicketFromClientDetailUseCase } from './application/get-ticket-from-client-detail.usecase';
import { RegisterTicketFromClientUseCase } from './application/register-ticket-from-client.usecase';
import { UpdateTicketFromClientFieldUseCase } from './application/update-ticket-from-client-field.usecase';

export const TICKET_FROM_CLIENT_PROVIDERS: Provider[] = [
  { provide: TICKET_FROM_CLIENT_REPOSITORY, useClass: HttpTicketFromClientRepository },
  GetTicketFromClientDetailUseCase,
  RegisterTicketFromClientUseCase,
  UpdateTicketFromClientFieldUseCase,
];
